import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { BackLinkService } from './back-link.service';
import { ModuleWithProviders, NgModule } from '@angular/core';
import { OrderModule } from 'ngx-order-pipe';
import { HeaderService } from '../components/header/header.service';
import { ThumbPipe } from './thumb.pipe';
import { SafePipe } from './safe.pipe';
import { CommonModule } from '@angular/common';
import { LoginDialogComponent } from './login-dialog/login-dialog.component';
import { LazyLoadImageModule } from 'ng-lazyload-image';
import { LazyLoadImagesModule } from 'ngx-lazy-load-images';
import { AmountPipe } from './amount.pipe';
import { IndexToCoverNamePipe } from './index-to-cover-name.pipe';
import { InViewportModule } from 'ng-in-viewport';
import { ScrollDispatchModule } from '@angular/cdk/scrolling';

@NgModule({
    imports: [
        FormsModule,
        ReactiveFormsModule,
        OrderModule,
        CommonModule,
        LazyLoadImageModule,
        LazyLoadImagesModule,
        InViewportModule,
        ScrollDispatchModule,
    ],
    exports: [
        FormsModule,
        ReactiveFormsModule,
        OrderModule,
        ThumbPipe,
        SafePipe,
        LoginDialogComponent,
        LazyLoadImageModule,
        LazyLoadImagesModule,
        AmountPipe,
        IndexToCoverNamePipe,
        InViewportModule,
        ScrollDispatchModule,
    ],
    providers: [],
    entryComponents: [LoginDialogComponent],
    declarations: [ThumbPipe, SafePipe, LoginDialogComponent, AmountPipe, IndexToCoverNamePipe],
})
export class SharedModule {
    static forRoot(): ModuleWithProviders {
        return {
            ngModule: SharedModule,
            providers: [BackLinkService, HeaderService],
        };
    }
}
